var React = require('react');

function Gem (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M110.327 15.329l-45.27 64.74-24.972-64.412zM35.24 19.685L59.8 83.029 0 82.665zM1.301 88.638l60.766.376 45.104 127.542zM112.643 214.127L68.41 89.05l44.507.274zM112.935 83.357l-42.717-.262 42.627-60.958.227-.316-.113 50.002zM231.884 82.665l-59.799.364 24.553-63.344zM191.799 15.657l-24.971 64.412-45.271-64.74zM118.926 71.823l-.114-50.002.221.316 42.633 60.958-42.716.262zM118.961 89.324l44.513-.274-44.232 125.077zM124.714 216.556l45.103-127.542 60.767-.376z"})));
}

Gem.defaultProps = {"viewBox":"0 0 231.884 231.884"};

module.exports = Gem;

Gem.default = Gem;
